import { render } from "./hospBiView.vue?vue&type=template&id=48f79285&scoped=true"
import script from "./hospBiView.vue?vue&type=script&lang=js"
export * from "./hospBiView.vue?vue&type=script&lang=js"

import "./hospBiView.vue?vue&type=style&index=0&id=48f79285&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f79285"]])

export default __exports__